module.exports = __webpack_public_path__ + "img/img_bed_app_popup_ko.ac0db580.png";